import $ from 'jquery';
import {unwrap} from 'core/helpers/dom';
import {getStickyHeaderHeight} from 'hpe-gn/hpe-gn.utils';

// TODO: Cleanup legacy jquery and use native scrollTo polyfill

/**
 * Move page scroll to {@param top} position
 * @param {number} top
 * @param {boolean | number} [duration] - move impliedly if false
 * @param {function} [callback] - a function to call once the animation is complete
 * */
export function scrollTo(top: number, duration: number = 500, callback?: () => void) {
  if (typeof duration === 'number') {
    $('html, body').stop().animate({scrollTop: top}, duration, 'swing', () => {
      if (callback) callback();
    });
  } else {
    $('html, body').scrollTop(top);
  }
}

/**
 * Scrolls the element's parent container such that the $el is visible
 */
export function scrollToElement(el: HTMLElement | JQuery, options: ScrollIntoViewOptions = {}) {
  const $el = unwrap(el);
  $el && $el.scrollIntoView(Object.assign({behavior: 'smooth'}, options));
}

/**
 * Move page scroll to the top
 * @param {boolean | number} [duration] - move impliedly if false
 * */
export function scrollToTop(duration = 500) {
  setTimeout(() => {
    if ($(window).scrollTop() > 0) {
      scrollTo(0, duration);
    }
  }, 0);
}

export function getAnchorNavHeight(): number {
  const $anHolder = document.querySelector<HTMLElement>('uc-anchor-holder');
  if ($anHolder) return $anHolder.offsetHeight;
  const $anchorNav = document.querySelector<HTMLElement>('.anchor-nav-v3.allow-sticky');
  return $anchorNav ? $anchorNav.offsetHeight : 0;
}

export function getCollateralStickyBarHeight(): number {
  const $stickyBar = document.querySelector<HTMLElement>('hpe-sticky-bar');
  return $stickyBar ? $stickyBar.offsetHeight : 0;
}

/**
 * Move page scroll to the element
 * @params {HTMLElement | JQuery } [el] - element to move to
 * {number} [delay] - time of scrolling
 * */
export function scrollToAdjusted(el: HTMLElement | JQuery, offset: number = 2) {
  const $el = $(el);
  if (!$el.length) return;
  const top = $el.offset().top + offset - getAnchorNavHeight() - getStickyHeaderHeight();
  window.scrollTo({
    top: Math.max(top, 0),
    behavior: 'smooth'
  });
}

/** Promisified version of scrollIntoView */
export function scrollIntoViewPromisified(el: HTMLElement, options: ScrollIntoViewOptions = {}): Promise<void> {
  return new Promise((resolve) => {
    el.scrollIntoView(options);
    const intersectionObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          resolve();
          intersectionObserver.unobserve(el);
        }, 100);
      }
    });
    intersectionObserver.observe(el);
  });
}
